<template>
  <div class="input-wrap" :class="{ 'is-row' :layout && layout === 'row', 'is-large': isLarge }">
    <label v-if="label" :for="id">{{label}}</label>
    <input
      :id="id"
      type="number"
      :placeholder="placeholder"
      v-model="localValue"
      :disabled="disabled"
      :required="required"
      @input="emit"
      :readonly="readonly"
      ref="element"
      :step="step"
      :min="min"
      :max="max"
    />
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  props: {
    id: String,
    min: Number,
    max: Number,
    value: [String, Number],
    type: String,
    label: String,
    placeholder: String,
    disabled: Boolean,
    layout: String,
    required: Boolean,
    autofocus: Boolean,
    isLarge: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      localValue: this.value,
      step: this.step || 'any',
    };
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.element.focus();
    }
  },
  methods: {
    isValidEmail(string) {
      return /\S+@\S+\.\S+/.test(string);
    },
    emit() {
      this.$emit('input', this.localValue);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/input.scss';

</style>
